<template>
  <v-layout class="px-3" column justify-center align-center fill-height>
    <div class="width-100">
      <v-fade-transition>
        <v-layout justify-center v-if="ready">
          <v-card class="rounded-5" width="100%" max-width="500px">
            <v-card-title class="justify-center font-weight-black">비밀번호 초기화</v-card-title>
            <!-- <v-card-subtitle class="text-center">
              아이디와 비밀번호를 입력하여 로그인해주세요.
            </v-card-subtitle> -->

            <v-card-text>
              <v-form @submit.prevent="passwordReset(user)">
                <v-text-field
                  type="password"
                  v-model="user.password"
                  label="비밀번호"
                  outlined
                  dense
                  :error="!!invalidMsg.password"
                  :rules="rules.password"
                  autocomplete="new-password"
                ></v-text-field>
                <v-text-field
                  type="password"
                  v-model="user.rePassword"
                  label="비밀번호 확인"
                  outlined
                  dense
                  :error="!!invalidMsg.rePassword"
                  :rules="rules.rePassword"
                  autocomplete="new-password"
                  ref="rePassword"
                ></v-text-field>

                <BasicButton
                  type="submit"
                  block
                  depressed
                  height="46"
                  :disabled="loading || !isValidAll"
                  :loading="loading"
                >
                  변경
                </BasicButton>

                <!-- <v-layout justify-center align-center class="mt-2">
                    <router-link :to="{ name: 'find/id' }">아이디 찾기</router-link>
                    <span class="mx-2">|</span>
                    <router-link :to="{ name: 'find/password' }">비밀번호 찾기</router-link>
                  </v-layout> -->
              </v-form>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-fade-transition>
    </div>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { getRedirectUriAndRemove, sleep } from '@/util'

export default {
  data() {
    return {
      user: {
        password: '',
        rePassword: '',
      },
      loading: false,
      invalidMsg: {
        password: null,
        rePassword: null,
      },
      rules: {
        password: [
          (value) => !!value || '패스워드를 입력해주세요',
          (value) => value.length > 5 || '6자 이상 입력해주세요',
        ],
        rePassword: [
          (value) => !!value || '패스워드를 입력해주세요',
          (value) => {
            return value === this.user.password || '비밀번호가 일치하지 않습니다.'
          },
        ],
      },
      passwordIsValid: false,
      rePasswordIsValid: false,
      ready: false,
    }
  },
  async mounted() {
    await sleep(200)
    this.ready = true
  },
  created() {},
  computed: {
    isValidAll() {
      return this.passwordIsValid && this.rePasswordIsValid
    },
    ...mapGetters('myfinbiz', ['isDefaultPlatform']),
    ...mapState('myfinbiz', ['organization']),
    resetUser() {
      return {
        token: this.$route.query.resetToken,
        newPassword: this.user.password,
        confirmPassword: this.user.rePassword,
      }
    },
  },
  watch: {
    'user.password'(password) {
      this.passwordValidate(password)
      this.rePasswordValidate(this.user.rePassword)
    },
    'user.rePassword'(rePassword) {
      this.rePasswordValidate(rePassword)
    },
  },
  methods: {
    ...mapMutations('status', ['refresh']),
    ...mapActions('auth', ['signinIdPassword', 'resetPassword']),
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]
        const isValid = rule(newVal)
        if (typeof isValid !== 'boolean') {
          msg = isValid
          break
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    passwordValidate(password) {
      const msg = this.getFormErrMsg('password', password)
      if (msg === null) {
        this.passwordIsValid = true
      } else {
        this.passwordIsValid = false
      }
      this.$refs.rePassword.validate()
    },
    rePasswordValidate(rePassword) {
      const msg = this.getFormErrMsg('rePassword', rePassword)
      if (msg === null) {
        this.rePasswordIsValid = true
      } else {
        this.rePasswordIsValid = false
      }
    },
    async movePage() {
      let redirectUri = getRedirectUriAndRemove()
      if (!redirectUri) {
        redirectUri = '/'
      }

      await this.$router.replace(redirectUri)
    },
    async passwordReset() {
      try {
        this.loading = true
        const { isConfirmed } = await this.$swal.basic.confirm('비밀번호를 변경하시겠습니까?')
        if (!isConfirmed) {
          return
        }
        await this.resetPassword(this.resetUser)
        await this.$swal.basic.success('변경이 완료되었습니다.')
        await this.movePage()
      } catch (e) {
        // if (e.status === 400) {
        //   this.user.password = ''
        // }
        throw e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
